import { computed, Injectable, signal } from '@angular/core';

interface ConsentStateModel {
  hasConsented: boolean | null;
  isLoading: boolean;
  showDialog: boolean;
}

@Injectable({ providedIn: 'root' })
export class ConsentState {
  private readonly state = signal<ConsentStateModel>({
    hasConsented: null,
    isLoading: false,
    showDialog: false,
  });

  public hasConsented = computed(() => this.state().hasConsented);
  public isLoading = computed(() => this.state().isLoading);
  public showDialog = computed(() => this.state().showDialog);

  public setHasConsented(value: boolean) {
    this.state.update((s) => ({
      ...s,
      hasConsented: value,
      showDialog: false,
    }));
  }

  public setLoading(value: boolean) {
    this.state.update((s) => ({ ...s, isLoading: value }));
  }

  public openDialog() {
    this.state.update((s) => ({ ...s, showDialog: true }));
  }

  public closeDialog() {
    this.state.update((s) => ({ ...s, showDialog: false }));
  }

  public reset() {
    this.state.set({
      hasConsented: null,
      isLoading: false,
      showDialog: false,
    });
  }
}
